"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _consts = require("../consts");

var _getButtonTypeToken = _interopRequireDefault(require("./getButtonTypeToken"));

var getButtonIconForeground = function getButtonIconForeground(_ref) {
  var theme = _ref.theme,
      type = _ref.type;

  var wrappedTypeToken = function wrappedTypeToken(name) {
    return (0, _getButtonTypeToken.default)(name, type, theme);
  };

  return {
    foreground: wrappedTypeToken(_consts.TOKENS.colorTextButton),
    foregroundHover: wrappedTypeToken(_consts.TOKENS.colorTextButtonHover),
    foregroundActive: wrappedTypeToken(_consts.TOKENS.colorTextButtonActive),
    foregroundFocus: wrappedTypeToken(_consts.TOKENS.colorTextButtonActive)
  };
};

var _default = getButtonIconForeground;
exports.default = _default;